import { Controller } from "stimulus"

class AdTrackingController extends Controller {
  static values = {
    urls: String
  }

  connect() {
    try {
      let urls = window.atob(this.urlsValue);
      let trackingURLs = JSON.parse(urls);

      (trackingURLs || []).forEach(u => {
        let e = document.createElement("script");
        e.setAttribute("src", u);
        e.setAttribute("type", "text/javascript");
        document.body.appendChild(e);
      });
    } catch (e) {
    }
  }
}

export default AdTrackingController
